import { Stack } from '@fluentui/react';
import { WelcomeName } from './WelcomeName';
import { SignInSignOutButton } from './SignInSignOutButton';

const stackStyles = {
    root: {
        flexGrow: 1,
        padding: '0px', // Add padding if needed
    },
};



const NavBar = () => {
    return (
        <Stack verticalAlign='center' horizontal horizontalAlign='end' styles={stackStyles} tokens={{ childrenGap: 10 }}>
            <WelcomeName />
            <SignInSignOutButton />
        </Stack>
    );
};

export default NavBar;

